import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "@/api/client";

const DAY = 24 * 60 * 60 * 1000;

export const locationKeys = {
  states: ["locations", "states"] as const,
  lgas: (stateId: number) => ["locations", "lgas", stateId] as const,
};

export function useStates() {
  return useQuery({
    queryKey: locationKeys.states,
    queryFn: () => unwrap(api.GET("/api/v1/locations/states/")),
    staleTime: DAY,
    gcTime: DAY,
  });
}

export function useLgas(stateId: number | null | undefined) {
  return useQuery({
    queryKey: locationKeys.lgas(stateId ?? 0),
    queryFn: () => unwrap(api.GET("/api/v1/locations/states/{state_id}/lgas/", { params: { path: { state_id: stateId as number } } })),
    enabled: !!stateId,
    staleTime: DAY,
    gcTime: DAY,
  });
}
